#
# Singleton static Utilities class
#
# Copyright 2016 Thomas Würsch Informatik
# Version 1.0.0

root = exports ? this

class Utilities
    
    # returns true if obj is of type Boolean
    @isBoolean: (obj) ->
        @_typeOf(obj) is 'boolean'
    
    # returns true if obj is of type Number
    @isNumber: (obj) ->
        @_typeOf(obj) is 'number'
    
    # returns true if obj is of type String
    @isString: (obj) ->
        @_typeOf(obj) is 'string'
    
    # returns true if obj is of type Function
    @isFunction: (obj) ->
        @_typeOf(obj) is 'function'
    
    # returns true if obj is of type Array
    @isArray: (obj) ->
        @_typeOf(obj) is 'array'
    
    # returns true if obj is of type Date
    @isDate: (obj) ->
        @_typeOf(obj) is 'date'
    
    # returns true if obj is of type RegExp
    @isRegExp: (obj) ->
        @_typeOf(obj) is 'regExp'
    
    # returns true if obj is of type Object
    @isObject: (obj) ->
        @_typeOf(obj) is 'object'
    
    # determine type of obj
    @_typeOf: (obj) ->
        if obj == undefined or obj == null
            return String obj
        classToType = {
            '[object Boolean]' : 'boolean',
            '[object Number]'  : 'number',
            '[object String]'  : 'string',
            '[object Function]': 'function',
            '[object Array]'   : 'array',
            '[object Date]'    : 'date',
            '[object RegExp]'  : 'regExp',
            '[object Object]'  : 'object'
        }
        return classToType[Object.prototype.toString.call(obj)]
    
    # recursively deep clone obj
    @clone: (obj) ->
        if not obj? or not @isObject obj
            return obj
        if @isDate obj
            return new Date(obj.getTime())
        if @isRegExp obj
            flags = ''
            flags += 'g' if obj.global?
            flags += 'i' if obj.ignoreCase?
            flags += 'm' if obj.multiline?
            flags += 'y' if obj.sticky?
            return new RegExp(obj.source, flags)
        newInstance = new obj.constructor()
        for key of obj
            newInstance[key] = @clone obj[key]
        return newInstance
    
    # test if obj is empty or blank
    @isEmpty: (obj) ->
        if obj is undefined or obj is null
            return true
        if @isArray obj
            return obj.length is 0
        if @isString obj
            return obj.trim().length is 0
        if @isObject obj
            return Object.keys(obj).length is 0
    
    # test if obj is not empty or blank
    @isNotEmpty: (obj) ->
        not @isEmpty(obj)
    
    # count occurrences of substr in str
    @countSubstring: (str, substr) ->
        n = i = 0
        while (pos = str.indexOf(substr, i)) != -1
            n++
            i = pos + substr.length
        n
    
    # random number between min (inclusive) and max (exclusive)
    @random: (min, max) ->
        Math.random() * (max - min) + min
    
    # random integer between min (inclusive) and max (inclusive)
    @randomInt: (min, max) ->
        Math.floor(Math.random() * (max - min + 1)) + min
    
    # unique id
    @uniqueId: (length = 6) ->
        id = ''
        id += Math.random().toString(36).substr(2) while id.length < length
        id.substr 0, length

    # delay execution of fn by time milliseconds
    @delay: (time, fn) ->
        setTimeout fn, time

    # get current locale date and time
    @dateNow: ->
        date = new Date
        new Date(date - (date.getTimezoneOffset() * 60 * 1000))

    # get ISO formatted time stamp string
    @timeStamp: ->
        @_formatDate(@dateNow(), 'ISO', true, true)

    # format date to ISO date format
    @formatDateISO: (date) ->
        @_formatDate(date, 'ISO')

    # format date to ISO date time format
    @formatDateTimeISO: (date) ->
        @_formatDate(date, 'ISO', true)

    # format date to swiss date format
    @formatDateCH: (date) ->
        @_formatDate(date, 'CH')

    # format date to swiss date time format
    @formatDateTimeCH: (date) ->
        @_formatDate(date, 'CH', true)

    # validate swiss format date string
    @validateDateCH: (dateString) ->
        if Utilities._validateAndConvertToDate(dateString) then true else false

    # convert swiss format date string to Date object, returns false if conversion fails
    @convertToDateCH: (dateString) ->
        Utilities._validateAndConvertToDate(dateString)

    # format date into a  string
    @_formatDate: (date, format, withTime = false, withMillis = false) ->
        dts = date.toISOString().replace(/[^\d-:\.]/g, ' ').trim()
        [d, t] = dts.split ' '
        d = if format is 'CH' then d.split('-').reverse().join('.') else d
        t = if withTime then (' ' + if withMillis then t else t.substr(0, 8)) else ''
        d + t

    # validate swiss format date string and convert it to Date object if valid
    @_validateAndConvertToDate: (dateString, countryCode = 'CH') ->
        regex = switch
            when countryCode is 'CH' then /^(0?[1-9]|[12][0-9]|3[01])\.(0?[1-9]|1[012])\.((19|20)\d{2}|\d{2})$/
        matches = regex.exec dateString.replace(/\s/g, '')
        if matches
            day = parseInt matches[1]
            month = parseInt(matches[2]) - 1
            year = parseInt matches[3]
            return Utilities._createDate year, month, day
        else
            return false

    # create new Date object
    @_createDate: (year, month, day) ->
        year = if year < 30 then year + 2000 else if year < 100 then year + 1900 else year
        date = new Date(Date.UTC(year, month, day, 0, 0, 0))
        date.getMonth() is month and date.getFullYear() is year and date
    
    # validate floating point number
    @isValidFloat = (value) ->
        if @validateAndFormatFloat value then true else false
    
    # validate and format floating point number
    @formatFloat = (value, decimals = 2) ->
        @validateAndFormatFloat value, decimals
    
    # validate and format floating point number
    @validateAndFormatFloat = (value, decimals = 2) ->
        regex = /^[-+]?[0-9]*\.?[0-9]+$/
        matches = regex.exec value.replace(/\s|'/g, '').replace(',', '.')
        if matches
            return parseFloat(matches[0]).toFixed(decimals)
        else
            return false
    
    # validate phone number for given country
    @isValidPhone: (phone, countryCode = 'CH') ->
        if @validateAndFormatPhone phone, countryCode then true else false

    # format phone number  for given country
    @formatPhone: (phone, countryCode = 'CH') ->
        @validateAndFormatPhone phone, countryCode

    # validate and format phone number for given country
    @validateAndFormatPhone: (phone, countryCode = 'CH') ->
        regex = switch
            when countryCode is 'CH' then /^(?:(?:|0{1,2}|\+{0,2})41(?:|\(0\))|0)([1-9]\d)(\d{3})(\d{2})(\d{2})$/
        matches = regex.exec(phone.replace(/\s/g, ''))
        if matches
            "0#{matches[1]} #{matches[2]} #{matches[3]} #{matches[4]}"
        else
            return false

    # validate social security number for given country
    @isValidSSN: (ssn, countryCode = 'CH') ->
        if @validateAndFormatSSN ssn, countryCode then true else false

    # format social security number for given country
    @formatSSN: (ssn, countryCode = 'CH') ->
        @validateAndFormatSSN ssn, countryCode

    # validate and format social security number for given country
    @validateAndFormatSSN: (ssn, countryCode = 'CH') ->
        regex = switch
            when countryCode is 'CH' then /^(\d{3})(\d{4})(\d{4})(\d{2})$/
        matches = regex.exec ssn.replace(/\s|\./g, '')
        if matches
            "#{matches[1]}.#{matches[2]}.#{matches[3]}.#{matches[4]}"
        else
            return false

#
# Logger
#
# based on https://github.com/muffin/Logger
#
# Copyright 2016 Thomas Würsch Informatik
# Version 1.0.0
#



# Writers

class ConsoleWriter

    write: (msg) ->
        console.log(msg)

class LocalStorageWriter

    constructor: (@maxEntries) -> {}

    write: (msg) ->
        s = localStorage['app:log']
        s = if s then JSON.parse(s) else []
        s.unshift msg
        s.pop() while s.length > @maxEntries
        try localStorage['app:log'] = JSON.stringify(s)

writers =
    'ConsoleWriter'     : ConsoleWriter
    'LocalStorageWriter': LocalStorageWriter


# Formatters

class SimpleFormatter
    format: (name, msg, datetime, level) ->
        "#{Utilities.formatDateTimeISO(datetime)} | #{level.name} | #{name} | #{msg}"

class JSONFormatter
    format: (name, msg, datetime, level) ->
        JSON.stringify {msg, datetime, name, level: level.name}

formatters =
    'SimpleFormatter': SimpleFormatter
    'JSONFormatter'  : JSONFormatter


# Logger

class Logger

    constructor: (@_className, options) ->
        @history = []
        @logLevel = @levels[options?.logLevel ? 'DEBUG']
        @maxEntries = options?.maxEntries ? 20
        formatterName = options?.formatter ? 'SimpleFormatter'
        @formatter = new formatters[formatterName]()
        writerName = options?.writer ? 'ConsoleWriter'
        @writer = new writers[writerName](@maxEntries)

    levels:
        TRACE: {value: 0, name: 'TRACE'}
        DEBUG: {value: 1, name: 'DEBUG'}
        INFO : {value: 2, name: 'INFO'}
        WARN : {value: 3, name: 'WARN'}
        ERROR: {value: 4, name: 'ERROR'}
        FATAL: {value: 5, name: 'FATAL'}

    clear: -> @history = []

    log: (level, msg) =>
        if level.value >= @logLevel.value
            msg = @formatter.format(@_className, msg, (new Date), level)
            @writer.write msg

            # Save to log history
            @history.unshift msg
            @history.pop() while @history.length > @maxEntries

    trace: (msg) ->
        @log @levels.TRACE, msg

    debug: (msg) ->
        @log @levels.DEBUG, msg

    info: (msg) ->
        @log @levels.INFO, msg

    warn: (msg) ->
        @log @levels.WARN, msg

    error: (msg) ->
        @log @levels.ERROR, msg

    fatal: (msg) ->
        @log @levels.FATAL, msg

#
# Base manager implementation
#
# Copyright 2016 Thomas Würsch Informatik
# Version 0.1.0



class BaseManager

    constructor: ->
        @logger = new Logger @constructor.name

    #
    # jQuery helpers
    #

    # convert given id to jQuery format
    jqId: (id) ->
        "##{id.replace /(:|\.|\[|\]|,|=)/g, '\\$1'}"

    # convert target to jQuery object if target is defined and a string otherwise return target
    jqObject: (target) ->
        if target and typeof target is 'string' then $(target) else target


#
# Handlebar template manager
#
# Compiles all Handlebars script elements on page and registers partial templates.
#
# providing the functions:
#	- get tplId
#
# Copyright 2016 Thomas Würsch Informatik
# Version 1.0.0

class TemplateManager extends BaseManager

  constructor: ->
    super()
    Handlebars.templates = {} unless Handlebars.templates
    @_compile()
    tplCount = Object.keys(Handlebars.templates).length
    partialCount = @_registerPartials()
    @logger.info "instantiated [template count = #{tplCount}, partial count = #{partialCount}]"


  # returns a precompiled template
  get: (id) ->
    Handlebars.templates[id]

  # compile all templates contained in current HTML page
  _compile: ->
    for id in $('script[type="text/x-handlebars-template"]').map(-> this.id).get()
      do (id) =>
        Handlebars.templates[id] = Handlebars.compile $('#' + id).html()

  # register partial templates with Handlebars
  _registerPartials: ->
    count = 0
    for k, v of Handlebars.templates
      # filter templates with IDs ending in '-ptpl'
      if /-ptpl$/.test k
        Handlebars.registerPartial k, v
        count++
    count

#
# View manager
#
# Copyright 2016 Thomas Würsch Informatik
# Version 0.1.0



class ViewManager extends BaseManager
    
    _menuHandlers: []
    
    constructor: ->
        super()
        @tplMgr = new TemplateManager()
        @logger.info 'instantiated'

    # register a click handler for a menu option
    registerMenuHandler: (id, handler) ->
        @_menuHandlers.push {id: id, handler: handler}
    
    # scroll to top of page
    scrollToTop: (position = 0) ->
        $('html, body').animate {scrollTop: position}, 'fast'
    
    # shake target element
    shake: ($target, shakes = 3, distance = 15, duration = 800) ->
        $target.shake shakes, distance, duration

    # append template and data to element specified by target selector
    append: (target, tplId, data) ->
        $target = @jqObject target
        tpl = @tplMgr.get tplId
        $target.append tpl(data)

    # update content of element specified by target with template and data
    update: (target, tplId, data) ->
        $target = @jqObject target
        tpl = @tplMgr.get tplId
        $target.html tpl(data)

    # update main page container template and data
    updatePage: (tplId, data, toTop = true) ->
        @update '#twi-main-container', tplId, data
        @scrollToTop() if toTop

    # insert menu into navigation bar menu container
    showMenu: ->
        $.get './menu'
        .done (data) =>
            $menuContainer = $('#navbar-menu-container')
            @update $menuContainer, 'system/nav-bar-menu-tpl', data
            for item in @_menuHandlers
                $link = $menuContainer.find("a[href='#{item.id}']")
                $link.on 'click', item.handler
                $link.on 'click', -> $('.navbar-toggle:visible').click()

    #
    showFormErrorMessages: (target, messages) ->
        @update target, 'system/form-error-messages-tpl', messages

#
# Base Controller implementation
#
# Copyright 2016 Thomas Würsch Informatik
# Version 0.1.0

class BaseController extends BaseManager
    
    constructor: ->
        super()

    #
    # page helpers
    #
    
    # find main container
    $mainContainer: ->
        $('#twi-main-container')

    #
    # form helpers
    #
    
    # find form in mainContainer
    $mainForm: ->
        @$mainContainer().find('form')

    # convert field name chars to allowed chars in HTML IDs and CSS class names
    convertFieldName: (fieldName) ->
        fieldName.replace /\]\.|[\.|\[|\]]/g, '-'

    # convert field name chars to HTML id allowed chars
    # TODO remove
    fieldNameToHtmlId: (fieldName) ->
        fieldName.replace /\]\.|[\.|\[|\]]/g, '-'
    
    # attach on click handler to the help buttons
    addHelpHandler: (target) ->
        $target = @jqObject target
        $helpBtn = if $target then $target.find('.twi-help-btn') else $('.twi-help-btn')
        $helpBtn.on 'click', ->
            $('#' + $(this).data 'help-id').modal()
    
    # format amount field content
    formatAmountField: (field) ->
        $field = @jqObject field
        if Utilities.isNotEmpty($field.val())
            value = Utilities.validateAndFormatFloat($field.val())
            $field.val value if value
    
    # format date field content
    formatDateField: (field) ->
        $field = @jqObject field
        if Utilities.isNotEmpty($field.val())
            date = Utilities.convertToDateCH $field.val()
            $field.val Utilities.formatDateCH(date) if date
    
    # format phone field content
    formatPhoneField: (field) ->
        $field = @jqObject field
        if Utilities.isNotEmpty($field.val())
            phone = Utilities.formatPhone($field.val())
            $field.val phone if phone

    # format SSN field content
    formatSSNField: (field) ->
        $field = @jqObject field
        if Utilities.isNotEmpty($field.val())
            ssn = Utilities.formatSSN($field.val())
            $field.val ssn if ssn

    # update checked property of radio and checkbox input fields in given $form according to given values
    updateCheckedFields: ($form, fieldName, values...) ->
        for value in values
            $form.find("input[name='#{fieldName}'][value='#{value}']").prop 'checked', true

    #
    # parsley validation helpers
    #
    
    # initialize Parsley
    initParsley: ->
        @addAmountValidator()
        @addDateValidator()
        @addPhoneValidator()
    
    # add amount validatorto Parsley
    addAmountValidator: ->
        Parsley.addValidator 'amount',
            requirementType: 'integer'
            validateString : (value, requirement) ->
                Utilities.validateAndFormatFloat value, requirement
    
    # add date validator to Parsley
    addDateValidator: ->
        Parsley.addValidator 'date',
            requirementType: 'string'
            validateString : (value, requirement) ->
                switch
                    when requirement is 'ch' and value then Utilities.validateDateCH value
    
    # add phone number validator to Parsley
    addPhoneValidator: ->
        Parsley.addValidator 'phone',
            requirementType: 'string'
            validateString : (value, requirement) ->
                switch
                    when requirement is 'ch' and value then Utilities.isValidPhone value

    # validation options
    validationOptions: ->
        successClass   : 'has-success'
        errorClass     : 'has-error'
        errorsContainer: @findErrorsContainer
        errorsWrapper  : '<span class="help-block"></span>'
        errorTemplate  : '<span class="twi-error"></span>'

    # find errors container for given parsley field
    findErrorsContainer: (field) =>
        $this = field.$element
        # try error-container data attribute
        selector = $this.data 'twi-error-container'
        $container = $(selector) if selector
        if not $container?.length
            # try fieldName
            fieldName = @convertFieldName $this.attr('name')
            # as CSS class
            $container = $(".twi-#{fieldName}-error")
            if not $container.length
                # and as HTML id
                $container = $("##{fieldName}-error")
        return $container

    # add parsley required attribute to given field
    addRequired: (field) ->
        $field = @jqObject field
        $field.attr 'data-parsley-required', true
        $field

    # remove parsley required attribute to given field
    removeRequired: (field) ->
        $field = @jqObject field
        $field.removeAttr 'data-parsley-required'
        $field

    #
    # table helper functions
    #

    # updates table column according priority for hiding unimportant columns on small screens
    updateTableColumnPriorities: (priorities) ->
        for priority, index in priorities
            @_addClassToTableColumn index, 'hidden-xs' if priority > 1
            @_addClassToTableColumn index, 'hidden-sm' if priority > 2
            @_addClassToTableColumn index, 'hidden-md' if priority > 3

    # add cssClass to table column at index in table head and body
    _addClassToTableColumn: (index, cssClass) ->
        $("table tr th:nth-child(#{index + 1}), table tr td:nth-child(#{index + 1})").addClass cssClass

#
# Welcome Controller is responsible for:
#
# - showing the welcome screen
# -
#
# Copyright 2016 Thomas Würsch Informatik
# Version 0.1.0

class WelcomeController extends BaseController
    
    constructor: (@viewMgr, @appCtrl) ->
        super()
        @logger.info 'instantiated'

    start: (pageType) ->
        switch pageType
            when 'asa' then @viewMgr.updatePage 'asa-welcome-page-tpl'
            when 'vks' then @viewMgr.updatePage 'vks-welcome-page-tpl'
            else @viewMgr.updatePage 'welcome-page-tpl'
        @_addButtonHandler()
        $('#twi-main-container button').focus()
        
    _addButtonHandler: ->
        $('#twi-main-container button').on 'click', (event) =>
            @appCtrl.process 'goHome'
#
# Regulations Controller is responsible for:
#
# - registers menu handlers
# -
#
# Copyright 2016 Thomas Würsch Informatik
# Version 0.1.0

class RegulationsController extends BaseController
    
    constructor: (@viewMgr, @appCtrl) ->
        super()
        @_registerMenuHandlers()
        @logger.info 'instantiated'
    
    # register menu handlers with ViewManager
    _registerMenuHandlers: ->
        lang = @appCtrl.language
        @viewMgr.registerMenuHandler 'asa_expenses', (event) =>
            event.preventDefault()
            window.open "./docs/asa-Spesenreglement-2025-#{lang}.pdf", '_blank'
        @viewMgr.registerMenuHandler 'asa_club', (event) =>
            event.preventDefault()
            window.open "./docs/asa-Vereinstaetigkeit-2016-#{lang}.pdf", '_blank'
        @viewMgr.registerMenuHandler 'asa_edu', (event) =>
            event.preventDefault()
            window.open "./docs/asa-Bildung-2016-#{lang}.pdf", '_blank'
        @viewMgr.registerMenuHandler 'asa_rg', (event) =>
            event.preventDefault()
            window.open "./docs/asa-Regionalgruppen-2019-#{lang}.pdf", '_blank'
        @viewMgr.registerMenuHandler 'asa_qs', (event) =>
            event.preventDefault()
            window.open "./docs/asa-QS-Experten-2022-#{lang}.pdf", '_blank'
        @viewMgr.registerMenuHandler 'vks_expenses', (event) =>
            event.preventDefault()
            window.open "./docs/vks-Spesenreglement-2022-#{lang}.pdf", '_blank'
        @viewMgr.registerMenuHandler 'vks_regulation', (event) =>
            event.preventDefault()
            window.open "./docs/vks-Entschaedigungsreglement-2017-#{lang}.pdf", '_blank'

#
# Profile Controller is responsible for:
#
# - register menu handler
# - handling profile edit form
#
# Copyright 2016 Thomas Würsch Informatik
# Version 0.1.0

class ProfileController extends BaseController
    
    constructor: (@viewMgr, @appCtrl) ->
        super()
        @_registerMenuHandlers()
        @logger.info 'instantiated'

    # load profile date and show form
    register: (accountId) ->
        request = $.get "./profile/#{accountId}"
        request.done (response) =>
            @_showForm response

    # load profile data and show form
    show: ->
        request = $.get './profile'
        request.done (response) =>
            @_showForm response

    # register menu handler with ViewManager
    _registerMenuHandlers: ->
        @viewMgr.registerMenuHandler 'profile',  (event) =>
            event.preventDefault()
            @show()

    # insert form in page using data
    _showForm: (data) ->
        @viewMgr.updatePage 'profile-edit-tpl', data
        @_$form = @$mainForm()
        @_initNewPasswordField data.config.registration
        @_initLanguageFields data.content.language
        @_initContactIdField()
        @_initRoleFields data.content.roles
        @_initDomainSettings data.content
        @_initAgreements data.content
        @_addFormCmdHandler()

    # on load add new password field handler
    _initNewPasswordField: (registration) ->
        $pwdField = @_$form.find('input[name="passwordNew"]')
        @addRequired $pwdField if registration
        $pwdField.on 'change', (event) =>
            $this = $(event.target)
            if Utilities.isNotEmpty $this.val()
                if @_$form.find('.twi-password-copy').length is 0
                    @viewMgr.append @_$form.find('.twi-password-new'), 'profile-password-copy-tpl'
                    @_$form.find('input[name="passwordCopy"]').focus()
            else
                @_$form.find('.twi-password-copy').remove()

    # on load init language fields
    _initLanguageFields: (language) ->
        @updateCheckedFields @_$form, 'language', language

    # on load init contact id field (format as SSN)
    _initContactIdField: ->
        @formatSSNField @_$form.find('input[name="contact.id"]')

    # on load init contact id field (format as SSN)
    _initRoleFields: (roles) ->
        @updateCheckedFields @_$form, 'roles', roles...

    # on load insert domain settings for all roles
    _initDomainSettings: (formData) ->
        for role in formData.roles
            domain = AppUtilities.roleToDomain(role)
            setting = formData.settings[domain] if formData.settings
            @_insertDomainSetting domain, setting

    # insert domain setting fields for given domain
    _insertDomainSetting: (domain, setting = {}) ->
        # prepare setting object
        setting.domain = domain
        switch domain
            when 'asa_club' then setting.asa_club = true
            when 'asa_edu' then setting.asa_edu = true
            when 'asa_rg' then setting.asa_rg = true
            when 'asa_qs' then setting.asa_qs = true
            when 'vks_club' then setting.vks_club = true
            when 'vks_edu' then setting.vks_edu = true
            when 'vks_type_test' then setting.vks_type_test = true
        # determine template and show it
        tplId = switch domain
            when 'asa_club', 'asa_edu', 'asa_rg', 'asa_qs', 'vks_club', 'vks_edu', 'vks_type_test' then 'profile-domain-specifics-tpl'
        @logger.info "unknown domain [domain = #{domain}, tplId = #{tplId}]"
        @viewMgr.append @$mainContainer().find('.twi-domain-specifics-container'), tplId, setting
        @_updateDomainSettingFields domain, setting

    # update employee domain setting fields based on employer settings
#    _updateDomainSettingFields: (domain, setting) ->
#        @logger.info domain
#        switch domain
#            when 'asa_club', 'asa_edu', 'asa_rg', 'asa_qs', 'vks_club', 'vks_edu', 'vks_type_test'
#                @_updateDomainSettingFields domain, setting
#            else
#                @logger.warn "unknown domain [domain = #{domain}]"

    # update employee domain setting fields based on employer settings
    _updateDomainSettingFields: (domain, setting) ->
        unless setting.flatRateEmployer is undefined
            flatRateEmployee = 100 - setting.flatRateEmployer
            @_$form.find("input[name='domainSettings[#{domain}].flatRateEmployee']").val flatRateEmployee
        unless setting.expensesEmployer is undefined
            @updateCheckedFields @_$form, "domainSettings[#{domain}].expensesEmployer", setting.expensesEmployer
            expensesEmployee = if setting.expensesEmployer is 100 then 0 else 100
            @updateCheckedFields @_$form, "domainSettings[#{domain}].expensesEmployee", expensesEmployee

    # on load show agreements view button
    _initAgreements: (formData) ->
        for role in formData.roles
            type = AppUtilities.roleToAgreementType role
            domain = AppUtilities.roleToDomain role
            agreement = formData.agreements[type] if formData.agreements
            if agreement then agreement.type = type else agreement = type: type
            agreement[type] = true
            @_insertAgreement domain, agreement

    # insert agreement upload template
    _insertAgreement: (domain, agreement) ->
        agreementType = AppUtilities.domainToAgreementType domain
        # check if agreement type is already inserted
        if @_$form.find(".twi-#{agreementType}-agreement-container").length is 0
            # determine template and show it
            tplId = switch domain
                when 'asa_club', 'asa_edu', 'asa_rg', 'asa_qs', 'vks_club', 'vks_edu', 'vks_type_test' then 'profile-agreement-tpl'
            @viewMgr.append @$mainContainer().find('.twi-agreement-container'), tplId, agreement

    # view agreement
    _viewAgreement: (docId) ->
        window.open "./accounts/agreement/#{docId}", '_blank'

    # attach click handlers to form command buttons
    _addFormCmdHandler: ->
        $cmdElements = @_$form.find '.twi-cmd-button'
        $cmdElements.on 'click', (event) =>
            $this = $(event.target)
            switch $this.data 'twi-cmd'
                when 'back' then @appCtrl.process 'goHome'
                when 'submit' then if @_formIsValid() then @_submitForm()
                when 'view' then @_viewAgreement($this.data 'document-id')

    # validate form
    _formIsValid: ->
        @_$form.parsley(@validationOptions()).validate()

    # submit form
    _submitForm: ->
        request = $.ajax
            url        : @_$form.attr('action')
            method     : 'post'
            data       : @_$form.serialize()
        request.done (response) =>
            if response.cmd is 'reload'
                window.location = window.location.pathname
            else
                @appCtrl.process 'goHome'

#
# Login page controller
#
# Copyright 2016 Thomas Würsch Informatik
# Version 1.0.0

class LoginController extends BaseController
    
    constructor: (@viewMgr, @appCtrl) ->
        super()
        @_$form = undefined
        @_registerMenuHandlers()
        @logger.info 'instantiated'
        
    # insert login form in page and attach submit handler
    showForm: ->
        @viewMgr.updatePage 'login-form-tpl'
        # select form and set focus on first input field
        @_$form = @$mainForm()
        @_$form.find('input[name="username"]').focus()
        # attach handlers
        @addHelpHandler @_$form
        @_addFormCmdHandler()

    # show login form in a modal dialog
    showLoginDialog: ->
        $loginDialog = $('#twi-login-modal')
        $loginDialog.modal('show')
    
    # post logout request and go to login page
    doLogout: ->
        jqXHR = $.post './logout', 'goodbye'
        jqXHR.done =>
            @appCtrl.process 'goLogin', footerKey: 'asa'

    # register menu handlers with ViewManager
    _registerMenuHandlers: ->
        @viewMgr.registerMenuHandler 'login',  (event) =>
            event.preventDefault()
            @doLogin()
        @viewMgr.registerMenuHandler 'logout', (event) =>
            event.preventDefault()
            @doLogout()

    # attach form command handler to command buttons
    _addFormCmdHandler: ->
        $cmdElements = @_$form.find '.twi-cmd-button'
        $cmdElements.on 'click', (event) =>
            $this = $(event.target)
            switch $this.data 'twi-cmd'
                when 'submit' then if @_formIsValid() then @_submitForm()
                when 'newPassword' then @_requestNewPassword()

    # validate form
    _formIsValid: ->
        @_$form.parsley(@validationOptions()).validate()

    # post form content
    _submitForm: ->
        jqXHR = $.post './login', @_$form.serialize()
        jqXHR.done (data) =>
            if data.code
                @viewMgr.showFormErrorMessages @_$form.find('.twi-form-error'), data.msg
                @logger.info "login failed [code = #{data.code}]"
            else
                @_requestHomeCommand()
                @logger.info 'login successful'

    # request new password
    _requestNewPassword: ->
        jqXHR = $.post './profile/resetPassword', { username: @_$form.find('input[name="username"]').val() }
        jqXHR.done (data) =>
            @_$form.find('.twi-new-password').addClass('hidden')
            @viewMgr.showFormErrorMessages @_$form.find('.twi-form-error'), data.msg
        jqXHR.fail (jqXHR) =>
            @viewMgr.showFormErrorMessages @_$form.find('.twi-form-error'), jqXHR.responseJSON.msg
            @logger.warn 'password reset failed'
            
    # execute home command in AppController after successful login
    _requestHomeCommand: ->
        jqXHR = $.get './homeCmd'
        jqXHR.done (data) =>
            @appCtrl.process data.cmd, footerKey: data.footerKey

#
# Help Controller is responsible for:
#
# - register menu handlers
# -
#
# Copyright 2016 Thomas Würsch Informatik
# Version 0.1.0

class HelpController extends BaseController
    
    constructor: (@viewMgr, @appCtrl) ->
        super()
        @_registerMenuHandlers()
        @logger.info 'instantiated'

    # register menu handlers with ViewManager
    _registerMenuHandlers: ->
        lang = @appCtrl.language
        @viewMgr.registerMenuHandler 'screencast-asa_club', (event) =>
            event.preventDefault()
            @_screenCastHandler 'asa_club'
        @viewMgr.registerMenuHandler 'screencast-asa_edu', (event) =>
            event.preventDefault()
            @_screenCastHandler 'asa_edu'
            
    # screen cast menu click handler
    _screenCastHandler: (domain) ->
        console.log "screencast start [domain = #{domain}, lang = #{@appCtrl.language}]"
        url = undefined
        if @appCtrl.language is 'de'
            url = switch domain
                when 'asa_club' then 'https://vimeo.com/blitzdonner/review/196871398/142b58cffc'
                when 'asa_edu' then 'https://vimeo.com/blitzdonner/review/196869630/042d97d512'
        else
            url = switch domain
                when 'asa_club' then 'https://vimeo.com/blitzdonner/review/196864309/ef0cbae6b1'
                when 'asa_edu' then 'https://vimeo.com/blitzdonner/review/196862897/810dd97d39'
        window.open url, '_blank'
        $.post './menu', {clickType: 'screenCast', domain: domain}
            
#
# Employer Export Controller is responsible for:
#
# - registers menu handler
# - validates form input
# -
#
# Copyright 2017 Thomas Würsch Informatik
# Version 0.1.0

class EmployerExportController extends BaseController
    
    constructor: (@viewMgr, @appCtrl) ->
        super()
        @_registerMenuHandlers()
        @logger.info 'instantiated'
    
    show: ->
        request = $.get './billing/export'
        request.done (response) =>
            @_showForm response
    
    _showForm: (data) ->
        @viewMgr.updatePage 'employer-export-tpl', data
        @_$form = @$mainForm()
        @_$form.find('input[name="fromDate"]').focus()
        @_addFieldHandlers()
        @_addFormCmdHandler()
    
    # register menu handler with ViewManager
    _registerMenuHandlers: ->
        @viewMgr.registerMenuHandler 'employerEvaluation', (event) =>
            event.preventDefault()
            @show()
    
    # attach change handler to form fields
    _addFieldHandlers: ->
        @_$form.find('input.twi-form-date').on 'change', (event) =>
            $this = $(event.target)
            if Utilities.isNotEmpty($this.val())
                @formatDateField $this
    
    # attach click handlers to form command buttons
    _addFormCmdHandler: ->
        $cmdElements = @_$form.find '.twi-cmd-button'
        $cmdElements.on 'click', (event) =>
            $this = $(event.target)
            switch $this.data 'twi-cmd'
                when 'submit' then if @_formIsValid() then @_requestDownload()
    
    # validate form
    _formIsValid: ->
        @_$form.parsley(@validationOptions()).validate()
    
    # request download using a hidden download link
    _requestDownload: ->
        query = @_$form.attr('action') + '/download?'
        query += @_$form.find('input[name="exportType"], input[name$="Date"], input[name="domains"]').serialize()
        $link = $('<a>',
            id      : 'download-link'
            href    : query
            download: 'export.zip'
            target  : '_blank'
        ).hide().appendTo('body')[0].click()
        $('#download-link').remove()
    
#
# Billing view controller
#
# Copyright 2016 Thomas Würsch Informatik
# Version 0.1.0

class BillingViewController extends BaseController
    
    constructor: (@viewMgr, @billingCtrl) ->
        super()
        @_pageData = undefined
        @_$form = undefined
        @_addAccountValidator()
        @_addCostCenterValidator()
        @logger.info 'instantiated'

    # load and show billing with given id
    show: (id) ->
        request = $.get "./billing/view/#{id}"
        request.done (response) =>
            @_display response
        request.fail @failHandler

    # add account validator to Parsley
    _addAccountValidator: ->
        Parsley.addValidator 'account',
            requirementType: 'string'
            validateString : (value, requirement) =>
                value in @_pageData.config.validationData.accounts
            messages:
                de: 'Konto unbekannt'

    # add cost center validator to Parsley
    _addCostCenterValidator: ->
        Parsley.addValidator 'costCenter',
            requirementType: 'string'
            validateString : (value, requirement) =>
                Utilities.isEmpty value or value in @_pageData.config.validationData.costCenters
            messages:
                de: 'Kostenstelle unbekannt'

    # display billing summary page
    _display: (data) ->
        @_pageData = data
        @viewMgr.updatePage 'billing-view-tpl', @_pageData
        @_$form = @$mainForm()
        @_addReceiptHandler()
        @_addAccountingInfoDateHandler() if @_pageData.config.signCmd
        $('input[type="text"]').attr 'disabled', 'disabled' unless @_pageData.config.signCmd
        @_addCmdHandlers()

    # attach click handler to receipt links
    _addReceiptHandler: ->
        @$mainContainer().find('.twi-receipt-links a').on 'click', (event) ->
            event.preventDefault()
            id = $(event.target).attr 'href'
            window.open "./billing/view/receipt/#{id}", '_blank'

    # attach change handler to accounting info date field
    _addAccountingInfoDateHandler: ->
        @_$form.find('input[name="accountingInfo.date"]').on 'change', (event) =>
            $this = $(event.target)
            if Utilities.isNotEmpty($this.val())
                @formatDateField $this

    # attach click handler to form command buttons
    _addCmdHandlers: ->
        @_$form.find('.twi-cmd-button').on 'click', (event) =>
            $this = $(event.target)
            switch $this.data 'twi-cmd'
                when 'back' then @_goBack $this.data('twi-target'), $this.data('twi-id')
                when 'submit' then @_doCommand $this.data('twi-id'), 'submit'
                when 'reject' then @_doCommand $this.data('twi-id'), 'reject'
                when 'sign' then @_doSign $this.data('twi-id')
                when 'finalizing' then @_doCommand $this.data('twi-id'), 'finalizing'
                when 'archive' then @_doCommand $this.data('twi-id'), 'archive'

    # go back to edit form if billing is open otherwise to billing list
    _goBack: (target, id) ->
        if target is 'edit'
            @billingCtrl.edit id
        else
            @billingCtrl.list()

    # post cmd with billing id
    _doCommand: (id, cmd) ->
        $.post "#{@_$form.attr('action')}/#{cmd}", {id: id}
            .done (data) =>
                @billingCtrl.list()

    # validate form and if valid post
    _doSign: (id) ->
        if @_$form.parsley(@validationOptions()).validate({force: false})
            request = $.ajax
                url        : "#{@_$form.attr('action')}/sign"
                method     : 'post'
                data       : @_$form.serialize()
            request.done (response) =>
                @billingCtrl.list()

#
# Billing list controller
#
# Copyright 2016 Thomas Würsch Informatik
# Version 0.1.0

class BillingListController extends BaseController
    
    $table = undefined
    
    constructor: (@viewMgr, @billingCtrl) ->
        super()
        @_registerMenuHandlers()
        @logger.info 'instantiated'
    
    # load list config / content and display
    show: ->
        request = $.get './billing/list'
        request.done (response) =>
            @_display response
        request.fail @failHandler
        @logger.info 'show list executed'
    
    # register menu handlers with ViewManager
    _registerMenuHandlers: ->
        @viewMgr.registerMenuHandler 'billings', (event) =>
            event.preventDefault()
            @show()
    
    # insert list into page
    _display: (list) ->
        # insert list template into main page container
        @viewMgr.updatePage 'billing-list-tpl', list
        @$table = @$mainContainer().find('table')
        # merge config from server with locale settings
        config = $.extend list.config,
            data      : list.content
            createdRow: (row, data, index) ->
                # add clickable class and action data attribute to row
                $(row).addClass('clickable').attr 'data-action', data.action
        # create table from config
        table = @$table.DataTable config
        # add handler for order and search events to put row sequence numbers in column 0
        table.on 'order.dt search.dt', ->
            table.column(0, {search: 'applied', order: 'applied'}).nodes().each (cell, i) ->
                cell.innerHTML = i + 1
        # draw table and update column display priority
        table.draw()
        @updateTableColumnPriorities list.columnPriorities
        # add handlers to new button, filter fields and table rows
        @_addNewBillingHandler()
        @_addFilterHandler()
        @_addRowHandler()
    
    # attach click handler to new billing buttons
    _addNewBillingHandler: ->
        @$mainContainer().find('.twi-new-button-container a').on 'click', (event) =>
            event.preventDefault()
            domain = $(event.target).attr 'href'
            request = $.get './billing/new/' + domain
            request.done (response) =>
                @billingCtrl.edit response
                @logger.info "edit new [domain = #{domain}]"
    
    # attach change handler to filter checkboxes
    _addFilterHandler: ->
        $form = @$mainForm()
        $form.find('input').on 'change', (event) =>
            request = $.get $form.attr('action'), $form.serialize()
            request.done (response) =>
                @_display response
    
    # attach click handler to list rows
    _addRowHandler: ->
        @$table.find('tbody').on 'click', 'tr', (event) =>
            event.stopPropagation()
            $this = $(event.currentTarget)
            switch $this.data 'action'
                when 'edit' then @_edit $this.attr 'id'
                when 'view' then @_view $this.attr 'id'
    
    # edit billing with given id
    _edit: (id) ->
        @billingCtrl.edit id
    
    # view billing with given id
    _view: (id) ->
        @billingCtrl.view id

#
# Billing edit controller
#
# Copyright 2016 Thomas Würsch Informatik
# Version 0.1.0

class BillingEditController extends BaseController
    
    _errorMsg:
        de:
            foodExpense: 'Sie müssen mindestens ein Feld ausfüllen.'
            receipt: 'Für Ihre Spesen müssen Sie Quittungen uploaden.'
        fr:
            foodExpense: 'Veuillez remplir au moins un champ.'
            receipt: 'Für Ihre Spesen müssen Sie Quittungen uploaden.'
    
    constructor: (@viewMgr, @billingCtrl) ->
        super()
        @initParsley()
        @logger.info 'instantiated'

    # insert form using given data, if data is String use it as id to load form data
    show: (data, scrollToTop = true) ->
        if typeof data is 'string'
            # load existing billing data and show form
            request = $.get "./billing/edit/#{data}"
            request.done (response) =>
                @_showForm response, scrollToTop
        else
            # show form using data (usually new billing)
            @_showForm data
    
    # insert form in page using data
    _showForm: (data, scrollToTop = true) ->
        @viewMgr.updatePage 'billing-edit-tpl', data, scrollToTop
        @_$form = @$mainForm()
        @_initEventFields data.config.event.options, data.config.event.prepare
        @_initRoleFields data.config, data.content
        @_initTravelExpense data.content
        @_initFoodExpense data.content
        @_initStayingExpense data.content
        @_initOtherExpenses data.config, data.content
        @_initReceipts data.content
        @_addFormCmdHandler()
        @_addSaveFeedback() unless scrollToTop
        @addHelpHandler @_$form
    
    #
    # event name and assignment field
    #
    
    # initialize event name and assignment date field on load
    _initEventFields: (events, prepare) ->
        # config Bloodhound
        options = new Bloodhound(
            datumTokenizer: Bloodhound.tokenizers.whitespace,
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            local         : events
        )
        options.initialize()
        # attach type ahead to event name field
        @_$form.find('input[name="eventName"]').typeahead
            source: options.ttAdapter()
        # attach change handler to assignment field
        @_$form.find('input[name="assignment"]').on 'change', (event) =>
            $this = $(event.target)
            if Utilities.isNotEmpty($this.val())
                @formatDateField $this

    #
    # role fields
    #
    
    # initialize roles on load
    _initRoleFields: (config, data) ->
        if config.asa_club or config.vks_club
            $container = @_$form.find('.twi-asa_club-roles-container')
            tplId = 'asa_vks_club-flat-rate-roles-tpl'
            if data.asa_club?.duration
                @updateCheckedFields @_$form, 'asa_club.duration', data.asa_club.duration
                if data.asa_club.duration isnt 'none'
                    @viewMgr.update $container, tplId
                    @updateCheckedFields $container, 'roles', data.roles... if data.roles
            $('input[name="asa_club.duration"]').on 'change', (event) =>
                $this = $(event.target)
                $component = $container.find('.twi-form-component')
                if $this.val() isnt 'none'
                    if $component.length is 0
                        @viewMgr.update $container, tplId
                        $component = $container.find('.twi-form-component')
                    else
                        $component.show()
                else
                    $component.hide() if $component.length isnt 0
        if config.asa_edu or config.vks_edu
            @updateCheckedFields @_$form, 'roles', data.roles... if data.roles
            # insert roles in corresponding containers
            if data.roles
                for role in data.roles
                    switch role
                        when 'director' then @_toggleDirector data.asa_edu
                        when 'writtenExam' then @_toggleWrittenExam data.asa_edu
                        when 'meeting' then null
                        else
                            @_toggleAssignment role, data.asa_edu[role]
            # attach change handler to roles checkboxes
            @_$form.find('input[name="roles"]').on 'change', (event) =>
                $this = $(event.target)
                role = $this.val()
                switch role
                    when 'director' then @_toggleDirector()
                    when 'writtenExam' then @_toggleWrittenExam()
                    when 'meeting' then null
                    else
                        @_toggleAssignment role
        if config.asa_qs
            @logger.info 'asa qs'
            if data.asa_qs
                if data.asa_qs.eventType
                    @updateCheckedFields @_$form, 'asa_qs.eventType', data.asa_qs.eventType
                else
                    @updateCheckedFields @_$form, 'asa_qs.eventType', 'audit'
                if data.asa_qs.duration
                    @updateCheckedFields @_$form, 'asa_qs.duration', data.asa_qs.duration
                else
                    @updateCheckedFields @_$form, 'asa_qs.duration', 'halfDay'
            else
                @updateCheckedFields @_$form, 'asa_qs.eventType', 'audit'
                @updateCheckedFields @_$form, 'asa_qs.duration', 'halfDay'
        if config.vks_type_test
            @updateCheckedFields @_$form, 'roles', data.roles... if data.roles
            if data.roles
                for role in data.roles
                    @_toggleAssignment role, data.vks_type_test[role], 'vks_type_test'
            # attach change handler to roles checkboxes
            @_$form.find('input[name="roles"]').on 'change', (event) =>
                $this = $(event.target)
                role = $this.val()
                if role is 'expert'
                    $meetingField = @_$form.find('input[name="roles"][value="meeting"]')
                    if $meetingField.prop 'checked'
                        $meetingField.prop('checked', false)
                        @_toggleAssignment 'meeting', null, 'vks_type_test'
                else
                    $expertField = @_$form.find('input[name="roles"][value="expert"]')
                    if $expertField.prop 'checked'
                        $expertField.prop('checked', false)
                        @_toggleAssignment 'expert', null, 'vks_type_test'
                @_toggleAssignment role, null, 'vks_type_test'

    # insert or show/hide director flat rate
    _toggleDirector: (data) ->
        $container = @_$form.find('.twi-asa_edu-director-container')
        $component = $container.find('.twi-form-component')
        if $component.length is 0
            @viewMgr.update $container, 'asa_edu-flat-rate-director-tpl'
            $component = $container.find('.twi-form-component')
            @updateCheckedFields $component, 'asa_edu.director', data.director if data?.director > -1
        else
            $component.toggle()
    
    # insert or show/hide flat rate assignment container
    _toggleAssignment: (role, assignments, domainKey = null) ->
        $container = @_$form.find(".twi-asa_edu-#{role}-container")
        $component = $container.find('.twi-form-component')
        if $component.length is 0
            @viewMgr.update $container, 'form-component-container-tpl'
            $component = $container.find('.twi-form-component')
            if assignments
                @_addAssignmentRow $component, role, assignment, domainKey for assignment in assignments
                @_addAssignmentRow $component, role, null, domainKey unless role is 'practicalExam' or role is 'meeting'
            else
                @_addAssignmentRow $component, role, null, domainKey
        else
            $component.toggle()
    
    # add flat rate assignment row
    _addAssignmentRow: ($component, role, assignment, domainKey = null) ->
        # init assignment if not given and add role to it
        assignment ?= {}
        assignment.role = role
        # find last assignment row, extract index number and add its increment to assignment
        $row = $component.find('.row:last-child')
        index = $row.data 'twi-row-index'
        assignment.index = if index? then index + 1 else 0
        # insert new assignment row
        switch domainKey
            when 'vks_type_test'
                templateName = 'vks_type_test-flat-rate-assignment-tpl'
                assignment.vksExpert = if role is 'expert' then true else false
            else
                templateName = 'asa_edu-flat-rate-assignment-tpl'
        @viewMgr.append $component, templateName, assignment
        $row = $component.find('.row:last-child')
        # update duration radio button if required, add field handlers and update validation
        if assignment.duration
            if domainKey is 'vks_type_test'
                @updateCheckedFields $row, "vks_type_test.#{assignment.role}[#{assignment.index}].duration", assignment.duration
            else
                @updateCheckedFields $row, "asa_edu.#{assignment.role}[#{assignment.index}].duration", assignment.duration
        @_addAssignmentFieldHandlers $component, $row, role
        @_updateAssignmentValidation $row
    
    # attach on change handler to flat rate assignment date field
    _addAssignmentFieldHandlers: ($component, $row, role) ->
        $row.find $('input.twi-form-date').on 'change', (event) =>
            $this = $(event.target)
            $currentRow = $this.closest('.row')
            if Utilities.isNotEmpty($this.val())
                @formatDateField $this
                currentRowIndex = $currentRow.data 'twi-row-index'
                lastRowIndex = $this.closest('.twi-form-component').find('.row:last-child').data 'twi-row-index'
                @_addAssignmentRow $component, role if lastRowIndex is currentRowIndex and role isnt 'practicalExam' and role isnt 'meeting'
            @_updateAssignmentValidation $currentRow
            
    # update validation of flat rate assignment row
    _updateAssignmentValidation: ($row) ->
        $dateField = $row.find('input.twi-form-date')
        $durationField = $row.find('input[type="radio"]').first()
        if Utilities.isNotEmpty $dateField.val()
            @addRequired $dateField
            @addRequired $durationField if $durationField.length
        else
            @removeRequired($dateField).parsley().reset()
            @removeRequired($durationField).parsley().reset() if $durationField.length
    
    # insert or show/hide written exam flat rate
    _toggleWrittenExam: (data) ->
        $container = @_$form.find('.twi-asa_edu-writtenExam-container')
        $component = $container.find('.twi-form-component')
        if $component.length is 0
            @viewMgr.update $container, 'asa_edu-flat-rate-writtenExam-tpl', data
            $component = $container.find('.twi-form-component')
            @addHelpHandler $component
        else
            $component.toggle()

    #
    # travel expenses
    #
    
    # initialize travel expenses on load
    _initTravelExpense: (data) ->
        @updateCheckedFields @_$form, 'noTravelExpense', data.noTravelExpense
        @_$form.find('input[name="noTravelExpense"]').on 'change', (event) =>
            @_toggleTravelExpense()
        @_toggleTravelExpense data.travelExpense unless data.noTravelExpense
    
    # insert or show/hide travel expenses
    _toggleTravelExpense: (data) ->
        selector = '.twi-travel-expense-container'
        $container = @_$form.find('.twi-travel-expense-container')
        $component = $container.find('.twi-form-component')
        if $component.length is 0
            @viewMgr.update $container, 'travel-expenses-tpl', data
            $component = $container.find('.twi-form-component')
            @updateCheckedFields $component, 'travelExpense.travelBy', data?.travelBy
            $component.find('input[name="travelExpense.travelBy"]').on 'change', (event) =>
                @_insertTravelDistanceOrCost $(event.target).val()
            @_insertTravelDistanceOrCost data.travelBy, data if data?.travelBy
            @addHelpHandler $container
        else
            $container.toggle()
    
    # insert travel distance
    _insertTravelDistanceOrCost: (travelBy, data) ->
        switch travelBy
            when 'car' then @_insertTravelDistance data
            when 'pt' then @_insertTravelCost data
    
    # insert travel distance
    _insertTravelDistance: (data) ->
        $container = @_$form.find('.twi-travel-distance-const-container')
        @viewMgr.update $container, 'travel-distance-tpl', data?.distance
        @addHelpHandler $container
    
    # insert travel distance
    _insertTravelCost: (data) ->
        $container = @_$form.find('.twi-travel-distance-const-container')
        @viewMgr.update $container, 'travel-cost-tpl', data?.cost
        @formatAmountField $container.find('input.twi-form-amount')
    
    #
    # food expenses
    #
    
    # initialize food expenses on load
    _initFoodExpense: (data) ->
        @updateCheckedFields @_$form, 'noFoodExpense', data.noFoodExpense
        @_$form.find('input[name="noFoodExpense"]').on 'change', (event) =>
            @_toggleFoodExpense()
        @_toggleFoodExpense data.foodExpense unless data.noFoodExpense
    
    # insert or show/hide food expenses
    _toggleFoodExpense: (data) ->
        $container = @_$form.find('.twi-food-expense-container')
        $component = $container.find('.twi-form-component')
        if $component.length is 0
            @viewMgr.update $container, 'food-expenses-tpl', data
            $component = $container.find('.twi-form-component')
            $component.find('input').on 'change', (event) ->
                $component.find('.twi-foodExpense-error').empty()
        else
            $component.toggle()
    
    #
    # staying expenses
    #
    
    # initialize staying expenses on load
    _initStayingExpense: (data) ->
        @updateCheckedFields @_$form, 'noStayingExpense', data.noStayingExpense
        @_$form.find('input[name="noStayingExpense"]').on 'change', (event) =>
            @_toggleStayingExpense()
        @_toggleStayingExpense data.stayingExpense unless data.noStayingExpense
    
    # insert or show/hide staying expenses
    _toggleStayingExpense: (data) ->
        $container = @_$form.find('.twi-staying-expense-container')
        $component = $container.find('.twi-form-component')
        if $component.length is 0
            @viewMgr.update $container, 'staying-expenses-tpl', data
            $component = $container.find('.twi-form-component')
            @formatAmountField $component.find('input.twi-form-amount')
            @_addStayingExpenseHandlers $component
        else
            $component.toggle()
    
    # attach staying expense on change handler
    _addStayingExpenseHandlers: ($container) ->
        $container.find('input.twi-form-date').on 'change', (event) =>
            $this = $(event.target)
            if Utilities.isNotEmpty($this.val())
                @formatDateField $this
        $container.find('input.twi-form-amount').on 'change', (event) =>
            $this = $(event.target)
            if Utilities.isNotEmpty($this.val())
                @formatAmountField $this
    
    #
    # other expenses
    #
    
    # initialize other expenses on load
    _initOtherExpenses: (config, data) ->
        @updateCheckedFields @_$form, 'noOtherExpenses', data.noOtherExpenses unless config.asa_rg
        @_$form.find('input[name="noOtherExpenses"]').on 'change', (event) =>
            @_toggleOtherExpenses()
        if not data.noOtherExpenses or config.asa_rg
            @_toggleOtherExpenses data.otherExpenses
    
    # insert or show/hide other expenses
    _toggleOtherExpenses: (data) ->
        $container = @_$form.find('.twi-other-expenses-container')
        $component = $container.find('.twi-form-component')
        if $component.length is 0
            @viewMgr.update $container, 'form-component-container-tpl'
            $component = $container.find('.twi-form-component')
            if data
                @_addOtherExpensesRow $component, expenses for expenses in data
            @_addOtherExpensesRow $component
        else
            $component.toggle()
    
    # append other expenses row
    _addOtherExpensesRow: ($component, expenses) ->
        expenses ?= {}
        expenses.index = $component.find('.row').length
        @viewMgr.append $component, 'other-expenses-tpl', expenses
        @formatAmountField $component.find('.row:last-child').find('input.twi-form-amount')
        @_addOtherExpensesHandlers $component
    
    # attach on change handler to last row in other expenses component
    _addOtherExpensesHandlers: ($component) ->
        $row = $component.find('.row:last-child')
        @_otherExpensesValidationHandler $row
        $row.find('input').on 'change', (event) =>
            $this = $(event.target)
            $currentRow = $this.closest '.row'
            @_otherExpensesValidationHandler $currentRow
        $row.find('input[name$="description"]').on 'change', (event) =>
            $this = $(event.target)
            if Utilities.isNotEmpty $this.val()
                $currentRow = $this.closest('.row')
                currentRowIndex = $currentRow.data 'twi-row-index'
                lastRowIndex = $this.closest('.twi-form-component').find('.row:last-child').data 'twi-row-index'
                @_addOtherExpensesRow $component if lastRowIndex is currentRowIndex
        $row.find('input.twi-form-amount').on 'change', (event) =>
            $this = $(event.target)
            if Utilities.isNotEmpty($this.val())
                @formatAmountField $this

    # otherExpenses validation attribute handler
    _otherExpensesValidationHandler: ($row) ->
        $descriptionField = $row.find 'input[name$="description"]'
        $amountField = $row.find 'input.twi-form-amount'
        if Utilities.isNotEmpty $descriptionField.val() then @addRequired $amountField else @removeRequired($amountField).parsley().reset()
        if Utilities.isNotEmpty $amountField.val() then @addRequired $descriptionField else @removeRequired($descriptionField).parsley().reset()
        
    #
    # receipts
    #
    
    # initialize receipts on load
    _initReceipts: (data) ->
        if data?.receipts
            for receipt, i in data.receipts
                receipt.index = i
                @viewMgr.append '#receipts', 'receipt-button-tpl', receipt
            @_attachReceiptsHandler()
        @_showUpload()
    
    # show uploads from group
    _showUpload: ->
        $('#upload').empty()
        @viewMgr.update '#upload', 'receipt-upload-tpl'
        @_attachUploadHandler()
    
    # attach on change handler to receipts file upload field
    _attachUploadHandler: ->
        $uploadField = $('#upload input:file')
        $uploadField.on 'change', (event) =>
            $this = $(event.target)
            if $this.get(0).files
                count = $this.get(0).files.length
                names = (file.name for file in $this.get(0).files)
            else
                count = 1
                names = $this.val().replace(/\\/g, '/').replace /.*\//, ''
            $this.trigger 'fileSelect', [count, names]
        $uploadField.on 'fileSelect', (event, count, names) =>
            $('#fileNames').val names.join ', '
            @_sendFormContent 'save'
    
    # attach on click handler to receipt button links
    _attachReceiptsHandler: ->
        $('#receipts a').on 'click', (event) =>
            event.preventDefault()
            $this = $(event.target)
            id = $this.attr 'href'
            switch $this.data 'action'
                when 'delete'
                    # mark receipt for deleting
                    $this.parents('div.btn-group').find('input[name$="name"]').val('__delete__')
                    @_sendFormContent 'save'
                when 'view'
                    window.open "./billing/view/receipt/#{id}", '_blank'
    
    #
    # form handling
    #
    
    # attache form command handler
    _addFormCmdHandler: ->
        $cmdElements = $('.twi-cmd-button')
        $cmdElements.on 'click', (event) =>
            switch $(event.target).data 'twi-cmd'
                when 'back' then @billingCtrl.list()
                when 'save' then @_sendFormContent 'save'
                when 'delete' then @_confirmDeleteBilling()
                when 'finish' then @_sendFormContent 'finish'
    
    # append success feedback to save button and remove it after 3 seconds
    _addSaveFeedback: ->
        @viewMgr.append @_$form.find('.twi-cmd-button').eq(1), 'button-success-tpl'
        Utilities.delay 3000, @_removeSaveFeedback
    
    # remove success feedback from save button
    _removeSaveFeedback: =>
        @_$form.find('.twi-cmd-button').eq(1).find('i').remove()

    # validate form content and if valid send it to server
    _sendFormContent: (cmd) ->
        # remove hidden form components
        @_$form.find('div.twi-form-component:hidden').remove()
        # add required attributes to other expenses fields
        if @_$form.find('input[name="noOtherExpenses"]:checked').val() is 'false'
            @addRequired @_$form.find('input[name="otherExpenses[0].description"]')
            @addRequired @_$form.find('input[name="otherExpenses[0].cost"]')
        if @_validateFormContent cmd
            @_submitMultipartForm cmd, @_$form, (response) =>
                switch cmd
                    when 'save' then @billingCtrl.edit response.id, false
                    when 'finish' then @billingCtrl.view response.id

    # validate form content -> return true when valid
    _validateFormContent: (cmd) ->
        options = switch cmd
            when 'save' then {group: 'minimum'}
            when 'finish' then {force: false}
        result = @_$form.parsley(@validationOptions()).validate(options)
        result = false if not @_validateFoodExpense()
        if @_$form.find('input[name="domain"]').val() is 'asa_rg' and cmd is 'finish'
            result = false if not @_validateReceipts()
        return result

    # validate food expenses fields -> return true when valid
    _validateFoodExpense: ->
        result = true
        if @_$form.find('input[name="noFoodExpense"]:checked').val() is 'false'
            mealsCount = 0
            @_$form.find('.twi-food-expense-container').find('input').each ->
                value = $(this).val()
                mealsCount += parseInt(value, 10) if value
            if mealsCount is 0
                lang = @billingCtrl.appCtrl.language
                @viewMgr.update @_$form.find('.twi-foodExpense-error'), 'system/form-error-tpl', @_errorMsg[lang].foodExpense
                result = false
        return result

    # validate receipts uploads -> return true when valid
    _validateReceipts: ->
        result = true
        if @_$form.find('#receipts button').length is 0
            lang = @billingCtrl.appCtrl.language
            @viewMgr.update @_$form.find('.twi-upload-error'), 'system/form-error-tpl', @_errorMsg[lang].receipt
            result = false
        return result
        
        
    # ajax post of multipart form using FormData object
    _submitMultipartForm: (cmd, $form, callback) ->
        $cmdElements = $form.find 'button'
        $cmdElements.prop 'disabled', true if $cmdElements
        formData = new FormData($form[0])
        if formData.entries
            # handling safari problem with nameless multipart files
            entries = formData.entries()
            entry = entries.next()
            while (not entry.done)
                if entry.value[0] is 'uploads' and entry.value[1].size is 0
                    formData.delete('uploads')
                entry = entries.next()
        request = $.ajax
            url        : $form.attr 'action'
            method     : 'post'
            data       : formData
            cache      : false
            contentType: false
            processData: false
        request.done (response) ->
            callback response
        request.fail (response) ->
            if response.status in [413, 415]
                $('#fileNames').val response.responseText
            else
                console.log response
        request.always ->
            $cmdElements.prop 'disabled', false if $cmdElements
    
    # show confirm dialog for deleting current billing
    _confirmDeleteBilling: ->
        bootbox.confirm
            title   : 'Abrechnung löschen?'
            message : 'ACHTUNG: Diese Aktion kann nicht mehr rückgängig gemacht werden!'
            buttons :
                confirm:
                    label: 'ja'
                cancel :
                    label: 'nein'
            callback: (result) =>
                @_deleteBilling() if result
            backdrop: true
    
    # delete current billing
    _deleteBilling: ->
        id = @_$form.find('input[name="id"]').val()
        request = $.ajax
            url   : "#{@_$form.attr('action')}/#{id}"
            method: 'delete'
        request.done =>
            @billingCtrl.list()

#
# Billing page controller
#
# Copyright 2016 Thomas Würsch Informatik
# Version 0.1.0

class BillingController extends BaseController
    
    constructor: (@viewMgr, @appCtrl) ->
        super()
        @listCtrl = new BillingListController(@viewMgr, @)
        @editCtrl = new BillingEditController(@viewMgr, @)
        @viewCtrl = new BillingViewController(@viewMgr, @)
        @logger.info 'instantiated'

    start: ->
        @listCtrl.show()
        
    list: ->
        @listCtrl.show()

    edit: (id, scrollToTop = true) ->
        @editCtrl.show id, scrollToTop

    view: (id) ->
        @viewCtrl.show id

#
# Singleton static application specific Utilities class
#
# Copyright 2016 Thomas Würsch Informatik
# Version 1.0.0

class AppUtilities
    
    # convert domain into agreementType
    @domainToAgreementType: (domain) ->
        switch domain
            when 'asa_club' then 'asa'
            when 'asa_edu' then 'asa'
            when 'asa_rg' then 'asa_rg'
            when 'asa_qs' then 'asa_qs'
            when 'vks_club' then 'vks'
            when 'vks_edu' then 'vks'
            when 'vks_type_test' then 'vks'
            else null
    
    # convert role into domain
    @roleToDomain: (role) ->
        switch role
            when 'asa_club_employee' then 'asa_club'
            when 'asa_edu_employee' then 'asa_edu'
            when 'asa_rg_employee' then 'asa_rg'
            when 'asa_qs_employee' then 'asa_qs'
            when 'vks_club_employee' then 'vks_club'
            when 'vks_edu_employee' then 'vks_edu'
            when 'vks_type_test_employee' then 'vks_type_test'
            else null

    # convert role into agreementType
    @roleToAgreementType: (role) ->
        AppUtilities.domainToAgreementType AppUtilities.roleToDomain(role)
    

#
# Account Controller is responsible for:
#
# - registers menu handlers
# -
#
# Copyright 2016 Thomas Würsch Informatik
# Version 0.1.0

class AccountController extends BaseController
    
    constructor: (@viewMgr, @appCtrl) ->
        super()
        @listCtrl = new AccountListController(@viewMgr, @)
        @editCtrl = new AccountEditController(@viewMgr, @)
        @logger.info 'instantiated'

    list: ->
        @listCtrl.show()

    edit: (id) ->
        @editCtrl.show id


#
# Application Controller is responsible for:
#
# - instantiation of required manager objects
# - instantiation of required controller objects with their dependencies
# - configure global ajax settings
# - extracting CSRF token from page header meta tag
# - process goHome command
#
# Copyright 2016 Thomas Würsch Informatik
# Version 0.1.0












class root.AppController extends BaseController
    
    constructor: (@language, @deviceIsMobile, @_footerKey, cmd) ->
        super()
        @viewMgr = new ViewManager()
        @welcomeCtrl = new WelcomeController(@viewMgr, @)
        @loginCtrl = new LoginController(@viewMgr, @)
        @billingCtrl = new BillingController(@viewMgr, @)
        @regulationsCtrl = new RegulationsController(@viewMgr, @)
        @profileCtrl = new ProfileController(@viewMgr, @)
        @helpCtrl = new HelpController(@viewMgr, @)
        @accountCtrl = new AccountController(@viewMgr, @)
        @employerExportCtrl = new EmployerExportController(@viewMgr, @)
        @_ajaxConfig()
        @_csrfToken = $('meta[name="csrfToken"]').attr 'content'
        @_addBrandClickHandler()
        @_startIdleTimeMonitor()
        @process cmd
        @logger.info "instantiated [language = #{@language}, deviceIsMobile = #{@deviceIsMobile}, footerKey = #{@_footerKey}, cmd = #{cmd}]"

    # process command
    process: (cmd, data = {}) ->
        @viewMgr.showMenu()
        @_footerKey ?= 'asa'
        @_footerKey = data.footerKey if data.footerKey
        footer = switch @_footerKey
            when 'asa' then {asa: true}
            when 'vks' then {vks: true}
            else {asa: true}
        @viewMgr.update 'footer', 'page-footer-tpl', footer
        switch cmd
            when 'goLogin' then @loginCtrl.showForm()
            when 'goWelcome-asa' then @welcomeCtrl.start 'asa'
            when 'goWelcome-vks' then @welcomeCtrl.start 'vks'
            when 'goWelcome-asa-vks' then @welcomeCtrl.start()
            when 'goHome' then @billingCtrl.start()
            when 'goRegister' then @profileCtrl.show()
            when 'doReload' then @_reloadApp()
            else @logger.warn "unknown command [cmd = #{cmd}]"
                
    # configure jquery global AJAX settings
    _ajaxConfig: ->
        # add CSRF token to modifying ajax requests of relative URLs
        $(document).ajaxSend (event, jqXHR, settings) =>
            @_resetIdleSeconds()
            modifying = ['POST', 'PUT', 'DELETE'].indexOf(settings.type) > -1
            if modifying and !(/^http:.*/.test(settings.url) || /^https:.*/.test(settings.url))
                jqXHR.setRequestHeader 'X-CSRF-TOKEN', @_csrfToken
        # update CSRF token contained in response header
        $(document).ajaxSuccess (event, jqXHR, settings) =>
            token = jqXHR.getResponseHeader('X-CSRF-TOKEN')
            @_csrfToken = token if token and token != @_csrfToken
        # handle 401 Unauthorized and 403 Forbidden HTTP status -> request login
        $(document).ajaxError (event, jqXHR, settings, thrownError) =>
            response = jqXHR.responseJSON
            switch response.status
                when 401 then @loginCtrl.showForm response.path
                when 403, 408 then @_reloadApp()
                else console.log response
            @logger.info "global ajaxError handler [status = #{response.status}]"

    # attache click handler to brand link in navigation bar
    _addBrandClickHandler: ->
        $('a.navbar-brand').on 'click', (event) =>
            event.preventDefault()
            @process 'goHome'

    # reload app in given language
    _reloadApp: ->
        window.location.reload()

    # reload app using given language
    _changeLanguage: (language) ->
        window.location = "./?lang=#{language}"
    
    # reload app when server session expires
    _SESSION_TIMEOUT = 60 * 31
    _idleSeconds = 0
    _resetIdleSeconds: ->
        _idleSeconds = 0
    _startIdleTimeMonitor: ->
        window.setInterval @_monitorIdleTime, 1000
    _monitorIdleTime: =>
        _idleSeconds++
        @_reloadApp() if _SESSION_TIMEOUT < _idleSeconds
    
#
# Account list controller
#
# Copyright 2016 Thomas Würsch Informatik
# Version 0.1.0

class AccountListController extends BaseController

    constructor: (@viewMgr, @accountCtrl) ->
        super()
        @_registerMenuHandlers()
        @logger.info 'instantiated'

    # load list config / content and display
    show: ->
        request = $.get './accounts'
        request.done (response) =>
            @_display response
        request.fail @failHandler
        @logger.info 'show list executed'

    # register menu handlers with ViewManager
    _registerMenuHandlers: ->
        @viewMgr.registerMenuHandler 'employees',  (event) =>
            event.preventDefault()
            @show()

    # insert list into page
    _display: (list) ->
        # insert list template into main page container
        @viewMgr.updatePage 'account-list-tpl', list.title
        # merge config from server with locale settings
        config = $.extend list.config,
            data: list.content
            createdRow: (row, data, index) ->
                # add clickable class and action data attribute to row
                $(row).addClass('clickable').attr 'data-action', data.action
        # create table from config
        table = $('#account-list').DataTable config
        # add handler for order and search events to put row sequence numbers in column 0
        table.on 'order.dt search.dt', ->
            table.column(0, {search: 'applied', order: 'applied'}).nodes().each (cell, i) ->
                cell.innerHTML = i + 1
        .draw()
        @_attachRowHandler()
    
    # attach row click handler
    _attachRowHandler: ->
        $('#account-list tbody').on 'click', 'tr', (event) =>
            event.stopPropagation()
            $this = $(event.currentTarget)
            @accountCtrl.edit $this.attr 'id'
#
# Account edit controller
#
# Copyright 2016 Thomas Würsch Informatik
# Version 0.1.0

class AccountEditController extends BaseController
    
    constructor: (@viewMgr, @accountCtrl) ->
        super()
        @_$form = undefined
        @logger.info 'instantiated'
    
    # insert form using given data, if data is String use it as id to load form data
    show: (data) ->
        if typeof data is 'string'
            request = $.get "./accounts/#{data}"
            request.done (response) =>
                @_showForm response
        else
            @_showForm data
    
    # insert form in page using data
    _showForm: (data) ->
        @viewMgr.updatePage 'employee-account-edit-tpl', data
        @_$form = @$mainForm()
        @_initContactFields()
        @_initRolesFields data.content.roles
        @_initDomainSettings data.content
        @_initAgreements data.content
        @updateCheckedFields @_$form, 'language', data.content.language
        @_addFormCmdHandler()
    
    # format social security number field content
    _initContactFields: ->
        @formatSSNField @_$form.find('input[name="contact.id"]')
    
    # on load update role checkboxes and attach change handler
    _initRolesFields: (roles) ->
        @updateCheckedFields @_$form, 'roles', roles...
        @_$form.find('input[name="roles"]').on 'change', (event) =>
            $this = $(event.target)
            domain = AppUtilities.roleToDomain $this.val()
            if $this.is(':checked')
                @_insertDomainSetting domain
                @_insertAgreement domain, type: AppUtilities.domainToAgreementType domain
            else
                @_removeDomainSpecificFields domain
    
    # on load insert domain settings for all roles
    _initDomainSettings: (formData) ->
        for role in formData.roles
            domain = AppUtilities.roleToDomain role
            setting = formData.settings[domain] if formData.settings
            @_insertDomainSetting domain, setting
    
    # insert domain setting fields for given domain
    _insertDomainSetting: (domain, setting = {}) ->
        # prepare setting object
        setting.domain = domain
        switch domain
            when 'asa_club' then setting.asa_club = true
            when 'asa_edu' then setting.asa_edu = true
            when 'asa_rg' then setting.asa_rg = true
            when 'asa_qs' then setting.asa_qs = true
            when 'vks_club' then setting.vks_club = true
            when 'vks_edu' then setting.vks_edu = true
            when 'vks_type_test' then setting.vks_type_test = true
        # determine template and show it
        tplId = switch domain
            when 'asa_club', 'asa_edu', 'asa_rg', 'asa_qs', 'vks_club', 'vks_edu', 'vks_type_test' then 'employee-account-domain-specifics-tpl'
        @viewMgr.append @$mainContainer().find('.twi-domain-specifics-container'), tplId, setting
        @_updateDomainSettingFields domain, setting
        @_addDomainSettingFieldHandlers domain

    # update employee domain setting fields based on employer settings
    _updateDomainSettingFields: (domain, setting) ->
        switch domain
            when 'asa_club', 'asa_edu', 'asa_rg', 'asa_qs', 'vks_club', 'vks_edu', 'vks_type_test'
                @_updateAsaDomainSettingFields domain, setting
            else
                @logger.warn "unknown domain [domain = #{domain}]"

    # update asa employee domain setting fields based on employer settings
    _updateAsaDomainSettingFields: (domain, setting) ->
        if domain is 'asa_rg' and setting.flatRateEmployer is undefined
            setting.flatRateEmployer = 0
            setting.expensesEmployer = 0
        unless setting.flatRateEmployer is undefined
            @_$form.find("input[name='domainSettings[#{domain}].flatRateEmployer']").val setting.flatRateEmployer
            flatRateEmployee = 100 - setting.flatRateEmployer
            @_$form.find("input[name='domainSettings[#{domain}].flatRateEmployee']").val flatRateEmployee
        unless setting.expensesEmployer is undefined
            @updateCheckedFields @_$form, "domainSettings[#{domain}].expensesEmployer", setting.expensesEmployer
            expensesEmployee = if setting.expensesEmployer is 100 then 0 else 100
            @updateCheckedFields @_$form, "domainSettings[#{domain}].expensesEmployee", expensesEmployee
    
    # attach on change handler to domain setting fields for given domain
    _addDomainSettingFieldHandlers: (domain) ->
        @_$form.find("input[name='domainSettings[#{domain}].flatRateEmployer']").on 'change', (event) =>
            $this = $(event.target)
            domain = $this.attr('name').split(/[\[\]]/)[1]
            @_updateDomainSettingFields domain, flatRateEmployer: $this.val()
        @_$form.find("input[name='domainSettings[#{domain}].expensesEmployer']").on 'change', (event) =>
            $this = $(event.target)
            domain = $this.attr('name').split(/[\[\]]/)[1]
            expensesEmployee = if $this.val() is '100' then 0 else 100
            @updateCheckedFields @_$form, "domainSettings[#{domain}].expensesEmployee", expensesEmployee
    
    # remove domain specific filed for given domain
    _removeDomainSpecificFields: (domain) ->
        @_$form.find(".twi-#{domain}-specifics-container").remove()
    
    # on load show agreements upload field and view button
    _initAgreements: (formData) ->
        for role in formData.roles
            type = AppUtilities.roleToAgreementType role
            domain = AppUtilities.roleToDomain role
            agreement = formData.agreements[type] if formData.agreements
            if agreement then agreement.type = type else agreement = type: type
            @_insertAgreement domain, agreement
        
    # insert agreement upload template
    _insertAgreement: (domain, agreement) ->
        agreementType = AppUtilities.domainToAgreementType domain
        agreement[agreementType] = true
        # check if agreement type is already inserted
        if @_$form.find(".twi-#{agreementType}-agreement-container").length is 0
            # determine template and show it
            tplId = switch domain
                when 'asa_club', 'asa_edu', 'asa_rg', 'asa_qs', 'vks_club', 'vks_edu', 'vks_type_test' then 'employee-account-agreement-upload-tpl'
            @viewMgr.append @$mainContainer().find('.twi-agreement-upload-container'), tplId, agreement
            @_addUploadHandler agreementType

    # attach on change handler to agreement file upload field
    _addUploadHandler: (agreementType) ->
        @_$form.find("input[name=#{agreementType}_agreement]").on 'change', (event) =>
            $this = $(event.target)
            name = $this.val().replace(/\\/g, '/').replace /.*\//, ''
            @_$form.find(".twi-filename-#{agreementType}").val name

    # view agreement
    _viewAgreement: (docId) ->
        window.open "./accounts/agreement/#{docId}", '_blank'

    # attach form command handler to command buttons
    _addFormCmdHandler: ->
        $cmdElements = @_$form.find '.twi-cmd-button'
        $cmdElements.on 'click', (event) =>
            $this = $(event.target)
            switch $this.data 'twi-cmd'
                when 'back' then @accountCtrl.list()
                when 'submit' then if @_formIsValid() then @_submitForm()
                when 'view' then @_viewAgreement($this.data 'document-id')
    
    # validate form
    _formIsValid: ->
        @_$form.parsley(@validationOptions()).validate()
    
    # send form content as multipart post
    _submitForm: ->
        $cmdElements = @_$form.find '.twi-cmd-button'
        $cmdElements.prop 'disabled', true if $cmdElements
        formData = new FormData(@_$form[0])
        request = $.ajax
            url        : @_$form.attr('action')
            method     : 'post'
            data       : formData
            cache      : false
            contentType: false
            processData: false
        request.done (response) =>
            @accountCtrl.list()
        request.fail (response) ->
            if response.status in [413, 415]
                console.log response.responseText
            else
                console.log response
        request.always ->
            $cmdElements.prop 'disabled', false if $cmdElements

